import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { ConformidadePage } from '../../conformidade/conformidade-page.tsx';
import {
  ConformidadeSearch,
  conformidadeLinkOf,
  conformidadeSearchOf,
  withEcosystem,
} from '../search/conformidade-search.ts';
import type { ConformidadeLink } from '../search/conformidade-search.ts';
import { InvalidLinkPage } from '../search/invalid-link-page.tsx';

// Declared inline: the route plugin splits `component` and `errorComponent` into lazy bindings it
// declares after the options. The URL tests mount `Route.options` in a memory router.
export const Route = createFileRoute('/conformidade')({
  validateSearch: Schema.toStandardSchemaV1(ConformidadeSearch),
  component: ConformidadeRoute,
  errorComponent: InvalidLinkPage,
});

// The ecosystem, the tab and the governance section are each another view: every change gets its
// own history entry, so the back button returns to the view before it.
function ConformidadeRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  const link = conformidadeLinkOf(Route.useSearch());
  const open = (next: ConformidadeLink): void => {
    void navigate({ search: conformidadeSearchOf(next) });
  };
  return (
    <ConformidadePage
      ecosystem={link.ecosystem}
      onEcosystem={(ecosystem) => {
        open(withEcosystem(link, ecosystem));
      }}
      tab={link.tab}
      onTab={(tab) => {
        open({ ...link, tab });
      }}
      workspaceTab={link.workspaceTab}
      onWorkspaceTab={(workspaceTab) => {
        open({ ...link, workspaceTab });
      }}
    />
  );
}
